module.exports = __webpack_public_path__ + "img/Gananms-logo.0156da73.png";